<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-clock-o"></i> {{ _('Scheduled reports') }}</h3>
        </div>
      </div>
      <Datatable :url="reportUrl" :options="tableOptions" ref="datatable" />
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import formatters from '~/lib/formatters'
import { Datatable } from '#components'
import debounce from 'lodash/debounce'
import reporttypes from '~/lib/reporttypes'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      reports: [],
      tableOptions: {
        responsiveLayoutCollapseFormatter: $this.collapseFormatter(),
        columns: [{
          title: 'ID',
          field: 'id',
          width: 60,
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'title',
          widthGrow: 5,
          responsive: 0
        },
        {
          title: _('Type'),
          field: 'type',
          widthGrow: 3,
          formatter: $this.reportTypeFormatter($this.reportTypes)
        },
        {
          title: _('Creator'),
          field: 'creator',
          widthGrow: 2
        },
        {
          title: _('Enabled'),
          field: 'enabled',
          widthGrow: 1,
          formatter: 'tickCross',
          cellClick (e, cell) {
            e.stopPropagation()
            $this.toggle(cell)
          }
        }],
        initialSort: [{
          column: 'title',
          dir: 'asc'
        }],
        rowClick (e, row) {
          $this.editReport(row)
        }
      }
    }
  },
  mixins: [components, formatters, reporttypes],
  computed: {
    reportUrl () {
      return this.baseDomain + this.shopId + '/scheduledreports.json?apikey=' + this.apiKey
    }
  },
  methods: {
    async editReport (row) {
      let id = row.getCell('id').getValue()
      let response = null
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/scheduledreports/' + id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        return
      }
      if (response && response.data) {
        let params = response.data
        this.EventBus.$emit('showCreateReportComponent', { shopId: this.shopId, events: [{ setCreateReportParams: params }]})
      }
    },
    toggle (cell) {
      let enabled = parseInt(cell.getValue())
      let id = cell.getRow().getCell('id').getValue()
      let obj = {
        id: id,
        enabled: enabled ? 0 : 1
      }
      try {
        axios.patch(this.baseDomain + this.shopId + '/scheduledreports/' + id + '.json?apikey=' + this.apiKey, obj)
      } catch(e) {
        return
      }
    },
    reload () {
      this.$refs.datatable.reload()
    }
  },
  components: {
    Datatable
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['scheduledReportUpdate'] = debounce((message) => {
        return this.reload()
      }, 200)
      this.events = events
    }
    this.enableEventBus()
  }

}

</script>